import React from 'react'

import { Box } from '@material-ui/core'

import BalanceCard from '~/balance/components/BalanceCard'
import { SubscriptionType, SubscriptionStatus, Subscription } from '~/customer/model/customer.model'
import ConsumptionCard from '~/subscriptionDetail/containers/ConsumptionCard'
import SubscriptionCard from '~/subscriptionDetail/containers/SubscriptionCard'
import GridTemplate3xN from '~/ui/components/GridTemplate3xN/GridTemplate3xN'

type MainSubscriptionCardContainerProps = {
  subscriptionNonFixed?: Subscription
  subscriptionFixed?: Subscription
}

const MainSubscriptionCardContainer: React.FC<MainSubscriptionCardContainerProps> = ({
  subscriptionNonFixed,
  subscriptionFixed,
}) => {
  const shouldShowBalanceCard =
    subscriptionNonFixed &&
    subscriptionNonFixed.type === SubscriptionType.PREPAID &&
    subscriptionNonFixed.status === SubscriptionStatus.ACTIVATED

  return (
    <Box data-hook="main-subscription-container">
      <GridTemplate3xN>
        <SubscriptionCard subscriptionNonFixed={subscriptionNonFixed} />
        <ConsumptionCard
          subscriptionNonFixed={subscriptionNonFixed}
          subscriptionFixed={subscriptionFixed}
        />
        {shouldShowBalanceCard && (
          <BalanceCard
            subscriptionNonFixed={subscriptionNonFixed}
            subscriptionFixed={subscriptionFixed}
          />
        )}
      </GridTemplate3xN>
    </Box>
  )
}

export default MainSubscriptionCardContainer
